import { render, staticRenderFns } from "./CategoryHistoryDia.vue?vue&type=template&id=156f8ac3&scoped=true&"
import script from "./CategoryHistoryDia.vue?vue&type=script&lang=js&"
export * from "./CategoryHistoryDia.vue?vue&type=script&lang=js&"
import style0 from "./CategoryHistoryDia.vue?vue&type=style&index=0&id=156f8ac3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f8ac3",
  null
  
)

export default component.exports